import type { ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
  showBranding?: boolean;
}

const stats = [
  { key: 'users', value: '10K+', label: 'Active Users' },
  { key: 'satisfaction', value: '98%', label: 'Satisfaction' },
  { key: 'support', value: '24/7', label: 'Support' },
];

const AuthLayout = ({ children, showBranding = true }: AuthLayoutProps) => (
  <div className="min-h-screen flex">
    {/* Left Side - Form */}
    <div className="flex-1 flex items-center justify-center p-8 bg-white">
      <div className="w-full max-w-[400px]">{children}</div>
    </div>

    {/* Right Side - Branding */}
    {showBranding && (
      <div className="hidden lg:flex flex-1 bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 p-12 items-center justify-center relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-64 h-64 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-white rounded-full blur-3xl" />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-lg text-white">
          <h2 className="text-4xl font-bold mb-4">Insurance made simple.</h2>
          <p className="text-lg text-white/80 leading-relaxed mb-12">
            Manage policies, process claims, and grow your business — all in one place.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8">
            {stats.map((stat) => (
              <div key={stat.key}>
                <div className="text-3xl font-bold mb-1">{stat.value}</div>
                <div className="text-sm text-white/60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
  </div>
);

AuthLayout.displayName = 'AuthLayout';

export default AuthLayout;
